import { render, staticRenderFns } from "./SingleTaskComponent.vue?vue&type=template&id=39a901ec&"
import script from "./SingleTaskComponent.vue?vue&type=script&lang=js&"
export * from "./SingleTaskComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports